
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2EYDP", function(module, exports) {

$parcel$export(module.exports, "attachAbortListeners", () => $1a78b7e80091176c$export$9010aa71841a6887);

var $d8F95 = parcelRequire("d8F95");

var $e39tT = parcelRequire("e39tT");

var $elyOj = parcelRequire("elyOj");
function $1a78b7e80091176c$export$9010aa71841a6887(window, initialViewPort, callback) {
    const unbindWheel = (0, $d8F95.bind)(window, {
        type: (0, $e39tT.AbortEvent).wheel,
        listener: (e)=>{
            callback((0, $e39tT.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    const unbindKeydown = (0, $d8F95.bind)(window, {
        type: (0, $e39tT.AbortEvent).keydown,
        listener: (e)=>{
            callback((0, $e39tT.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    const unbindResize = (0, $d8F95.bind)(window, {
        type: (0, $e39tT.AbortEvent).resize,
        listener: (e)=>{
            if ((0, $elyOj.getViewportWidth)() !== initialViewPort.w || (0, $elyOj.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $e39tT.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}

});
parcelRegister("d8F95", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $i8mvW = parcelRequire("i8mvW");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $i8mvW.bind;
    }
});

var $gVKck = parcelRequire("gVKck");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $gVKck.bindAll;
    }
});

});
parcelRegister("i8mvW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $d33a702db7709aff$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $d33a702db7709aff$var$bind;

});

parcelRegister("gVKck", function(module, exports) {
"use strict";
var $c535ce21396ab537$var$__assign = module.exports && module.exports.__assign || function() {
    $c535ce21396ab537$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c535ce21396ab537$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $i8mvW = parcelRequire("i8mvW");
function $c535ce21396ab537$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $c535ce21396ab537$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $c535ce21396ab537$var$__assign($c535ce21396ab537$var$__assign({}, original), {
        options: $c535ce21396ab537$var$__assign($c535ce21396ab537$var$__assign({}, $c535ce21396ab537$var$toOptions(sharedOptions)), $c535ce21396ab537$var$toOptions(original.options))
    });
    return binding;
}
function $c535ce21396ab537$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $c535ce21396ab537$var$getBinding(original, sharedOptions);
        return (0, $i8mvW.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $c535ce21396ab537$var$bindAll;

});


parcelRegister("e39tT", function(module, exports) {

$parcel$export(module.exports, "AbortEvent", () => $2fd4bed2a879aa78$export$199edc0307b5587f);
const $2fd4bed2a879aa78$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

});

parcelRegister("elyOj", function(module, exports) {

$parcel$export(module.exports, "getViewportWidth", () => $82c51b218c57a7bd$export$a497a1dcb4408212);
$parcel$export(module.exports, "getViewportHeight", () => $82c51b218c57a7bd$export$4f01c15d21ef9cc6);
function $82c51b218c57a7bd$export$a497a1dcb4408212(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $82c51b218c57a7bd$export$4f01c15d21ef9cc6(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});



var $2EYDP = parcelRequire("2EYDP");

var $elyOj = parcelRequire("elyOj");
function $ecacdc4534090d1e$export$7c71cffb8af72558(document, window) {
    const viewport = {
        w: (0, $elyOj.getViewportWidth)(document),
        h: (0, $elyOj.getViewportHeight)(document)
    };
    const aborts = {};
    const unbinds = (0, $2EYDP.attachAbortListeners)(window, viewport, (key, time)=>{
        aborts[key] = time;
    });
    window.__SSR_ABORT_LISTENERS__ = {
        unbinds: unbinds,
        aborts: aborts
    };
}


// Runs before the HTML body, it is NOT safe to assume SSR has been successful rendered
// This is why we don't check for `window.__SSR_RENDERED__` here
(0, $ecacdc4534090d1e$export$7c71cffb8af72558)(document, window);


//# sourceMappingURL=ssr-scripts-before.1eafc90b.js.map
